import { createFileRoute } from '@tanstack/react-router';

import { LocationsPage } from '../modules/locations/ui/pages/LocationsPage';

export const Route = createFileRoute('/_authenticated/dashboard/locations/')({
  component: LocationsPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations'],
  },
});
